export default "__VITE_ASSET__aAwifqH9__"